<template>
  <div :class="['wizard-nav', `mode-${mode}`]">
    <div
      :key="step.label"
      :class="[
        'step',
        step.hasSteps.indexOf(activeStep) > -1 ? 'active' : '',
        enabledStep(i) ? '' : 'disabled'
      ]"
      v-for="(step, i) in steps"
        @click="enabledStep(i) && $emit('step-clicked', step, i)"
        v-tooltip.top-center="{
        content:
          !enabledStep(i) && activeStep !== i ? localize('step unavailable yet') : null
      }"
    >
      <!-- @click="$emit('step-clicked', step, i)" -->
      <span class="step-num" v-text="i + 1"></span>
      <span class="step-label mt-s" v-text="localize(step.label)"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      required: true
    },
    // Is active step valid.
    validStep: {
      type: Boolean,
      default: false
    },
    // Mode (create || update || ..)
    mode: String,
    activeStep: Number,
    totalSteps: Number
  },
  data() {
    return {
      dirtySteps: []
    };
  },
  watch: {
    activeStep() {
      if (this.dirtySteps.indexOf(this.activeStep) < 0) {
        this.dirtySteps.push(this.activeStep);
      }
    }
  },
  mounted() {
    this.dirtySteps.push(this.activeStep);
  },
  methods: {
    /* Step navigation circle should be enabled
      Will ensure step is enabled if:
      Current step is valid && requested step has been visited before
      
      or current step is valid && requested step is the next one.
    */
    enabledStep(i) {
      return (
        (this.validStep && this.activeStep + 1 == i) || this.isDirtyStep(i)
      );
      //  (
      //   (this.validStep && this.isDirtyStep(i)) ||
      //   (this.validStep && this.activeStep + 1 == i)
      // );
    },
    // Step has been active before
    isDirtyStep(i) {
      return this.dirtySteps.indexOf(i) > -1;
    }
  }
  // computed: {
  //   __event() {
  //     return this.mode === "update" ? "click" : null;
  //   }
  // }
};
</script>

<style lang="stylus">

.wizard-nav
  position relative
  _flex(row, nowrap, center, space-between)
  .step
    position relative
    z-index 5
    cursor pointer
    span
      display block
    &-num
      round(75, 'px')
      font-size 40px
      font-weight 200
      font-family "Open Sans", "Helvetica Neue", sans-serif
      text-align center
      line-height 70px
      background #fff
      color #0076c0
      border 3px solid blue_brand
      transition color 0.3s ease-out, border 0.3s ease-out
    &-label
      position absolute
      white-space nowrap
      left 50%
      transform translateX(-50%)
      font-size responsive 12px 14px
      font-weight 300
      text-align center
      transition color 0.3s ease-out, border-color 0.3s ease-out
    &.disabled
      cursor default
      // pointer-events none
      .step-num
        // border-color rgba(blue_brand, 0.4)
        color #8ad1fe
    &.active .step-num
      background blue_brand
      color #fff
    &.active .step-label
      color blue_brand
  &:after
    content ''
    position absolute
    height 2px
    width 100%
    top 50%
    transform translateY(-50%)
    background blue_brand
</style>
